export default "__VITE_ASSET__BHO5KFTy__"